module.exports = {"230718001":"乌马河街道","230718002":"锦山街道","230718003":"曙光街道","230718004":"向阳街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230718.json
// module id = 846
// module chunks = 0